import { Box, makeStyles } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CONSTANTS } from '../../../core/config/constants';
import { FontSizes } from '../../../core/config/mainTheme';

interface Props {
  label: string;
  consolidated?: string;
  unconsolidated?: string;
  children?: ReactNode;
}

const ContentBlockConsolidatedParam: React.FC<Props> = ({
  label,
  consolidated,
  unconsolidated,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const consolidatedPref =
    consolidated && unconsolidated ? `${t('companies:consolidation:consolidated')}:` : '';
  const unconsolidatedPref =
    consolidated && unconsolidated ? `${t('companies:consolidation:unconsolidated')}:` : '';

  return (
    <>
      <Box className={classes.label}>{label}</Box>
      {consolidated && <Box className={classes.value}>{`${consolidatedPref} ${consolidated}`}</Box>}
      {unconsolidated && (
        <Box className={classes.value}>{`${unconsolidatedPref} ${unconsolidated}`}</Box>
      )}
      {!consolidated && !unconsolidated && CONSTANTS.EMPTY_VALUE}
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  label: {
    textTransform: 'uppercase',
    fontSize: FontSizes.size.small,
    color: theme.palette.grey[500],
  },
  value: {
    fontSize: FontSizes.size.medium,
    color: theme.palette.grey[900],
    wordBreak: 'break-all',
    whiteSpace: 'pre-line',
  },
}));

export default ContentBlockConsolidatedParam;
